import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBlankCrest = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 253.22 296.1",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M126.61,296.1c-40.5,0-75.27-19.85-100.55-57.41C7.47,211.08.59,183.72.31,182.57l-.31-2.52V46.04L126.61,0l126.61,46.04-.31,136.53c-.28,1.15-7.16,28.51-25.75,56.12-25.28,37.56-60.05,57.41-100.55,57.41Z" })
});
export default SvgBlankCrest;
